/**
 * Divisions (D4 → D1) selon le total d'étoiles (moteur + pneu ou pilotage + défense, 2–10★).
 */

import type { Car } from './car.js';
export { carPower } from './car.js';

export type DivisionId = 1 | 2 | 3 | 4;

export type DivisionShortLabel = 'D1' | 'D2' | 'D3' | 'D4';

export interface Division {
  id: DivisionId;
  shortLabel: DivisionShortLabel;
  pyramidRank: 1 | 2 | 3 | 4;
  name: string;
  /** Total étoiles min (inclus) — engine + tire */
  powerMin: number;
  powerMax: number;
}

export const DIVISION_COUNT = 4 as const;

/** Effectif championnat par division (D1–D4). */
export const DRIVERS_PER_DIVISION = 24;
export const CARS_PER_DIVISION = 24;

export const DIVISIONS: Division[] = [
  {
    id: 1,
    shortLabel: 'D1',
    pyramidRank: 4,
    name: 'Division 1',
    powerMin: 8,
    powerMax: 10,
  },
  { id: 2, shortLabel: 'D2', pyramidRank: 3, name: 'Division 2', powerMin: 6, powerMax: 8 },
  { id: 3, shortLabel: 'D3', pyramidRank: 2, name: 'Division 3', powerMin: 4, powerMax: 6 },
  { id: 4, shortLabel: 'D4', pyramidRank: 1, name: 'Division 4', powerMin: 2, powerMax: 4 },
];

export const DIVISION_IDS_PYRAMID_BOTTOM_TO_TOP: readonly DivisionId[] = [4, 3, 2, 1];

export function promotionTarget(divisionId: DivisionId): DivisionId | null {
  if (divisionId <= 1) return null;
  return (divisionId - 1) as DivisionId;
}

export function relegationTarget(divisionId: DivisionId): DivisionId | null {
  if (divisionId >= 4) return null;
  return (divisionId + 1) as DivisionId;
}

export const DEFAULT_SEASON_MOVEMENT = {
  promotedPerSeason: 2,
  relegatedPerSeason: 2,
} as const;

/** Ramène un total d'étoiles à [2, 10]. */
export function clampStarTotal(total: number): number {
  return Math.min(10, Math.max(2, total));
}

export function isStarTotalInDivisionBand(total: number, divisionId: DivisionId): boolean {
  const div = DIVISIONS.find((d) => d.id === divisionId);
  if (!div) return false;
  const t = clampStarTotal(total);
  return t >= div.powerMin && t <= div.powerMax;
}

export function eligibleDivisionIdsForStarTotal(total: number): DivisionId[] {
  const t = clampStarTotal(total);
  return DIVISIONS.filter((d) => t >= d.powerMin && t <= d.powerMax).map((d) => d.id);
}

export function getCarDivision(car: Pick<Car, 'division'>): DivisionId | undefined {
  const d = car.division;
  if (d != null && d >= 1 && d <= 4) return d as DivisionId;
  return undefined;
}
